import { styled, withStyle } from 'baseui';
import { themedUseStyletron } from '../../../theme/customTheme'
import { ValueDisplay } from '../../components/ValueDisplay'
import { IFlapVar } from './types'
import { MdAmpStories  } from "react-icons/md";

const ORIENTATION = Object.freeze({
    column: 'column',
    row: 'row',
} as const);

type Orientation = (typeof ORIENTATION)[keyof typeof ORIENTATION];

type SmallPanelProps = {
    orientation?: Orientation | undefined
} & IFlapVar

export function SmallPanel(props: SmallPanelProps) {
    const [, theme] = themedUseStyletron();

    return (
        <Container $orientation={props.orientation}>
            <MdAmpStories  color={props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='25px' />
            <ValueDisplay  mini value={props.actPosition ? props.actPosition : props.setPosition} dimension='%'></ValueDisplay>
        </Container>
    );
}

const Container = styled<'div', { $orientation }>('div', ({ $theme, $orientation }) => ({
    display: 'flex',
    gap: $theme.sizing.scale100,
    flexDirection: $orientation ?? 'row',
    alignItems: 'center'
}))